import * as React from "react";
const SvgFiRrRulerTriangle = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-ruler-triangle_svg__a)">
      <path
        fill="#062147"
        d="M22.824 17.18 6.821 1.176C5.656.012 3.986-.322 2.467.311A3.93 3.93 0 0 0 0 4.002v14.991A5.013 5.013 0 0 0 5.007 24h14.991a3.93 3.93 0 0 0 3.691-2.467 3.93 3.93 0 0 0-.865-4.354m-.981 3.59A1.94 1.94 0 0 1 19.999 22H5.007A3.01 3.01 0 0 1 2 18.993V4.003c0-.836.46-1.525 1.232-1.845a1.945 1.945 0 0 1 2.175.433l1.611 1.611L5.11 6.11a.999.999 0 1 0 1.414 1.414l1.908-1.908 1.466 1.466L7.99 8.99a.999.999 0 1 0 1.414 1.414l1.908-1.908 1.415 1.414-1.908 1.908a.999.999 0 1 0 1.414 1.414l1.908-1.908 1.414 1.414-1.908 1.908a.999.999 0 1 0 1.414 1.414l1.908-1.908 1.414 1.414-1.908 1.908a.999.999 0 1 0 1.414 1.414l1.908-1.908 1.611 1.611c.59.591.752 1.404.433 2.176zm-11.135-4.477A1 1 0 0 1 10.001 18h-3a1 1 0 0 1-1-1v-3a1 1 0 0 1 1.707-.707z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-ruler-triangle_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrRulerTriangle;
